/**
 * Tracking des soumissions de formulaires (dataLayer / GTM).
 *
 * Pousse un event unique `generate_lead` avec un paramètre `form_type` qui
 * distingue les 3 catégories demandées par le marketing :
 *   - 'contact'    : formulaire de contact (GF 1, demande générale / « Question »)
 *   - 'visite'     : formulaire de contact (GF 1) avec « Type de demande » = Visite
 *   - 'estimation' : funnel d'estimation (GF 5)
 *
 * Deux mécaniques, car les confirmations diffèrent :
 *   - GF 1 redirige vers une page merci → le filtre PHP `gform_confirmation_1`
 *     ajoute `?pdw_lead=1&form_type=…` ; on lit ces params au chargement.
 *   - GF 5 affiche un message AJAX dans la modal (pas de redirection) → on écoute
 *     l'event jQuery `gform_confirmation_loaded`.
 *
 * Le push est inconditionnel ; c'est GTM (+ Complianz / Consent Mode) qui gère
 * le consentement avant de déclencher les tags.
 */
(function () {
	window.dataLayer = window.dataLayer || [];

	function pushLead(formType) {
		if (!formType) {
			return;
		}
		window.dataLayer.push({ event: 'generate_lead', form_type: formType });
	}

	// 1) Form contact (GF 1) : arrivée sur la page merci avec ?pdw_lead=1&form_type=…
	function fromQueryString() {
		var params = new URLSearchParams(window.location.search);
		if (params.get('pdw_lead') !== '1') {
			return;
		}
		var type = params.get('form_type');
		if (type !== 'contact' && type !== 'visite') {
			type = 'contact';
		}
		pushLead(type);

		// Nettoyer l'URL pour éviter un nouveau push au refresh / partage du lien.
		params.delete('pdw_lead');
		params.delete('form_type');
		var qs = params.toString();
		window.history.replaceState(
			null,
			'',
			window.location.pathname + (qs ? '?' + qs : '') + window.location.hash
		);
	}

	// 2) Funnel estimation (GF 5) : confirmation = message AJAX (la modal reste).
	if (window.jQuery) {
		window.jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
			if (parseInt(formId, 10) === 5) {
				pushLead('estimation');
			}
		});
	}

	if (document.readyState !== 'loading') {
		fromQueryString();
	} else {
		document.addEventListener('DOMContentLoaded', fromQueryString);
	}
})();
